import { RelocationOrderBranchRejectStatus } from "@/api-schema-enums";

interface RejectReasonOptionProps {
  value: RelocationOrderBranchRejectStatus;
  label: string;
  description: string;
  icon: React.ReactNode;
  isSelected: boolean;
  select: (value: RelocationOrderBranchRejectStatus) => void;
}

export function RejectReasonOption({ value, label, description, icon, isSelected, select }: RejectReasonOptionProps) {
  return (
    <button
      type="button"
      onClick={() => select(value)}
      className={`flex w-full cursor-pointer items-start gap-3 rounded-lg border-2 p-4 text-left transition-colors ${
        isSelected ? "border-primary bg-primary/5" : "border-border hover:border-primary/50 hover:bg-accent"
      }`}
    >
      <div className={`mt-0.5 shrink-0 ${isSelected ? "text-primary" : "text-muted-foreground"}`}>{icon}</div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">{label}</div>
        <div className="text-muted-foreground mt-0.5 text-xs">{description}</div>
      </div>
    </button>
  );
}
